import { getInArr } from '../../../helpers/getInArr';
import { jsonConvert } from '../../../helpers/jsonConvert';

const textToInlineContent = (text) => {
	const content = [];
	const inlineLatexRegex = /\$([^$\n]+?)\$|\\\(([\s\S]+?)\\\)/g;
	let lastIndex = 0;
	let match = inlineLatexRegex.exec(text);

	while (match) {
		const textBeforeLatex = text.slice(lastIndex, match.index);
		const latex = match[1] ?? match[2] ?? '';

		if (textBeforeLatex) {
			content.push(...textToAutoMathContent(textBeforeLatex));
		}

		if (latex.trim()) {
			content.push({
				type: 'inlineMath',
				attrs: {
					value: latex.trim(),
				},
			});
		}

		lastIndex = match.index + match[0].length;
		match = inlineLatexRegex.exec(text);
	}

	const textAfterLatex = text.slice(lastIndex);
	if (textAfterLatex) {
		content.push(...textToAutoMathContent(textAfterLatex));
	}

	return content.length ? content : undefined;
};

const textToAutoMathContent = (text) => {
	const content = [];
	const bareFormulaRegex = /\\[A-Za-z]+(?:_\{?[-+]?[A-Za-z0-9]+\}?)?(?:\^\{?[-+]?[A-Za-z0-9]+\}?)?(?:\s*[A-Za-z0-9]+(?:[.,]\d+)?)?|[A-Za-z][A-Za-z0-9]*(?:\^\{?[-+]?[A-Za-z0-9]+\}?)(?:[+\-*/][A-Za-z0-9]+(?:\^\{?[-+]?[A-Za-z0-9]+\}?)?)*/g;
	let lastIndex = 0;
	let match = bareFormulaRegex.exec(text);

	while (match) {
		const textBeforeFormula = text.slice(lastIndex, match.index);

		if (textBeforeFormula) {
			content.push({ type: 'text', text: textBeforeFormula });
		}

		content.push({
			type: 'inlineMath',
			attrs: {
				value: match[0],
			},
		});

		lastIndex = match.index + match[0].length;
		match = bareFormulaRegex.exec(text);
	}

	const textAfterFormula = text.slice(lastIndex);
	if (textAfterFormula) {
		content.push({ type: 'text', text: textAfterFormula });
	}

	return content.length ? content : [{ type: 'text', text }];
};

const textToParagraphs = (text) => (
	`${text}`.split(/\r?\n/).map((line) => ({
		type: 'paragraph',
		content: line ? textToInlineContent(line) : undefined,
	}))
);

const textToTipTapContent = (text) => {
	const content = [];
	const blockLatexRegex = /\$\$([\s\S]+?)\$\$|\\\[([\s\S]+?)\\\]/g;
	let lastIndex = 0;
	let match = blockLatexRegex.exec(text);

	while (match) {
		const textBeforeLatex = text.slice(lastIndex, match.index);
		const latex = match[1] ?? match[2] ?? '';

		if (textBeforeLatex) {
			content.push(...textToParagraphs(textBeforeLatex));
		}

		if (latex.trim()) {
			content.push({
				type: 'math',
				attrs: {
					value: latex.trim(),
				},
			});
		}

		lastIndex = match.index + match[0].length;
		match = blockLatexRegex.exec(text);
	}

	const textAfterLatex = text.slice(lastIndex);
	if (textAfterLatex) {
		content.push(...textToParagraphs(textAfterLatex));
	}

	return content.length ? content : [{ type: 'paragraph' }];
};

// значение по умолчанию для tipTap
const tipTapValueDefault = (text) =>
	text
		? {
				type: 'doc',
				content: textToTipTapContent(text),
		  }
		: { type: 'doc' };
// поля значение, которых идут для tipTap
const tipTapList = ['question', 'key_text', 'prompt'];

export const formateData = {
	getAll: (data) => {
		const props = formateData.getValuesList(data.props);
		return { ...data, props };
	},
	getValuesList: (data) => {
		const props = {};
		for (let key in data) {
			const value = data[key];
			if (getInArr(key, tipTapList)) {
				const defaultValue = jsonConvert(value, 'json');
				if (typeof defaultValue === 'string') {
					props[key] = tipTapValueDefault(defaultValue);
					continue;
				} else if (!defaultValue.type) {
					props[key] = tipTapValueDefault();
					continue;
				}
			}
			props[key] = jsonConvert(value, 'json');
		}
		return props;
	},
};
